module.exports = __webpack_public_path__ + "img/full3-min.bb514d0f.png";